"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4108],{

/***/ 44612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ SlugLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var SlugLink = function(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var slug = router.query.slug;
    var href = props.href, alias = props.as;
    if (typeof slug === "string") {
        if (typeof href === "string") {
            href = "/".concat(slug).concat(href);
        }
        if (typeof alias === "string") {
            alias = "/".concat(slug).concat(alias);
        }
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], _objectSpread({}, props, {
        href: href,
        as: alias
    })));
};


/***/ }),

/***/ 6195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ AuthFormWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99226);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46574);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62623);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28492);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);



var AuthFormWrapper = function(param) {
    var title = param.title, children = param.children, _size = param.size, size = _size === void 0 ? "sm" : _size;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                children: [
                    title,
                    " | Flourishing Life"
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                sx: {
                    backgroundColor: "primary.theme",
                    display: "flex",
                    flexDirection: "column",
                    minHeight: "100vh"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    maxWidth: size,
                    sx: {
                        py: "80px"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            sx: {
                                display: "flex",
                                justifyContent: "center"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                alt: "FL Logo",
                                src: "/logos/flourish-logo-full.svg",
                                width: 170,
                                height: 170
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            sx: {
                                display: "flex",
                                justifyContent: "center",
                                mb: 8
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                sx: {
                                    display: "flex",
                                    flexDirection: "column",
                                    p: 4
                                },
                                children: children
                            })
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 91252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ LoginHeader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99226);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23972);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4374);




var LoginHeader = function() {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$)().t;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        sx: {
            mb: 2
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                color: "textPrimary",
                gutterBottom: true,
                variant: "h4",
                children: t("login.title.title")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                color: "textSecondary",
                variant: "body2",
                children: t("login.title.label")
            })
        ]
    }));
};


/***/ }),

/***/ 37195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ LoginForm; }
/* harmony export */ });
/* harmony import */ var _tmp_tmp_1932_8tSoM0oNwCe5_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _tmp_tmp_1932_8tSoM0oNwCe5_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tmp_tmp_1932_8tSoM0oNwCe5_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(99226);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(74509);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69397);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(67720);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47034);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82580);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4374);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74231);
/* harmony import */ var components_SlugLink__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44612);
/* harmony import */ var components_form_FormikTextField__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9952);
/* harmony import */ var constants_routes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46648);
/* harmony import */ var hooks_useAuth__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78470);
/* harmony import */ var hooks_useSlugRouter__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14794);












function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var extendRoute = function(route, slug, isGeneral) {
    if (isGeneral) {
        return "/".concat(slug).concat(route);
    }
    return route;
};
var LoginForm = function(param1, props) {
    var _isGeneral = param1.isGeneral, isGeneral = _isGeneral === void 0 ? false : _isGeneral;
    var router = (0,hooks_useSlugRouter__WEBPACK_IMPORTED_MODULE_9__/* .useSlugRouter */ .r)();
    var login = (0,hooks_useAuth__WEBPACK_IMPORTED_MODULE_8__/* .useAuth */ .a)().login;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_10__/* .useTranslation */ .$)().t;
    var loginFormSchema = yup__WEBPACK_IMPORTED_MODULE_4__/* .object */ .Ry({
        username: yup__WEBPACK_IMPORTED_MODULE_4__/* .string */ .Z_().required(t("login.email.error")),
        password: yup__WEBPACK_IMPORTED_MODULE_4__/* .string */ .Z_().required(t("login.password.error")),
        slug: yup__WEBPACK_IMPORTED_MODULE_4__/* .string */ .Z_().required(t("login.instance.error")),
        submit: yup__WEBPACK_IMPORTED_MODULE_4__/* .string */ .Z_()
    });
    var handleSubmitLogin = function() {
        var _ref = _asyncToGenerator(_tmp_tmp_1932_8tSoM0oNwCe5_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values, param) {
            var setErrors, setSubmitting, status, ref, ref1, error, ref2;
            return _tmp_tmp_1932_8tSoM0oNwCe5_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setErrors = param.setErrors, setSubmitting = param.setSubmitting;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return login({
                            username: values.username,
                            password: values.password,
                            slug: values.slug
                        });
                    case 4:
                        status = _ctx.sent;
                        setSubmitting(false);
                        _ctx.t0 = status;
                        _ctx.next = _ctx.t0 === "FORCE_CHANGE_PASSWORD" ? 9 : _ctx.t0 === "NEED_MFA" ? 12 : _ctx.t0 === "CONFIRMED" ? 15 : 18;
                        break;
                    case 9:
                        _ctx.next = 11;
                        return router.push({
                            pathname: extendRoute(constants_routes__WEBPACK_IMPORTED_MODULE_7__/* .ROUTES.AUTH_CHANGE_PASSWORD */ .Z.AUTH_CHANGE_PASSWORD, values.slug, isGeneral),
                            query: {
                                username: values.username
                            }
                        });
                    case 11:
                        return _ctx.abrupt("break", 20);
                    case 12:
                        _ctx.next = 14;
                        return router.push({
                            pathname: extendRoute(constants_routes__WEBPACK_IMPORTED_MODULE_7__/* .ROUTES.AUTH_VERIFY_MFA */ .Z.AUTH_VERIFY_MFA, values.slug, isGeneral),
                            query: {
                                username: values.username
                            }
                        });
                    case 14:
                        return _ctx.abrupt("break", 20);
                    case 15:
                        _ctx.next = 17;
                        return router.push(extendRoute("", values.slug, isGeneral));
                    case 17:
                        return _ctx.abrupt("break", 20);
                    case 18:
                        _ctx.next = 20;
                        return router.push(constants_routes__WEBPACK_IMPORTED_MODULE_7__/* .ROUTES.AUTH_LOGIN */ .Z.AUTH_LOGIN);
                    case 20:
                        _ctx.next = 29;
                        break;
                    case 22:
                        _ctx.prev = 22;
                        _ctx.t1 = _ctx["catch"](1);
                        ;
                        error = _ctx.t1;
                        ;
                        setErrors({
                            submit: (ref2 = (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) !== null && ref2 !== void 0 ? ref2 : error.message
                        });
                        setSubmitting(false);
                    case 29:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    22
                ]
            ]);
        }));
        return function handleSubmitLogin(values, _) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_2__/* .Formik */ .J9, {
        initialValues: {
            username: "",
            password: "",
            slug: router.slug
        },
        validationSchema: loginFormSchema,
        onSubmit: handleSubmitLogin,
        enableReinitialize: true,
        children: function(param) {
            var errors = param.errors, isSubmitting = param.isSubmitting, values = param.values;
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_2__/* .Form */ .l0, _objectSpread({}, props, {
                children: [
                    isGeneral && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_form_FormikTextField__WEBPACK_IMPORTED_MODULE_6__/* .FormikTextField */ .f, {
                        name: "slug",
                        margin: "normal",
                        label: t("login.instance.label"),
                        type: "text"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_form_FormikTextField__WEBPACK_IMPORTED_MODULE_6__/* .FormikTextField */ .f, {
                        name: "username",
                        margin: "normal",
                        autoComplete: "username",
                        label: t("login.email.useremail"),
                        type: "username"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_form_FormikTextField__WEBPACK_IMPORTED_MODULE_6__/* .FormikTextField */ .f, {
                        name: "password",
                        margin: "normal",
                        autoComplete: "password",
                        label: t("login.password.label"),
                        type: "password"
                    }),
                    errors.submit && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        sx: {
                            mt: 3
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            error: true,
                            children: errors.submit
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        sx: {
                            mt: 2
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            disabled: isSubmitting,
                            fullWidth: true,
                            size: "large",
                            type: "submit",
                            variant: "contained",
                            children: t("login.loginbutton")
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        sx: {
                            my: 2
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                        children: [
                            values.slug && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_SlugLink__WEBPACK_IMPORTED_MODULE_5__/* .SlugLink */ .$, {
                                href: constants_routes__WEBPACK_IMPORTED_MODULE_7__/* .ROUTES.AUTH_JOIN_CODE */ .Z.AUTH_JOIN_CODE,
                                passHref: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                    color: "textSecondary",
                                    variant: "body2",
                                    children: "Have a join code?"
                                })
                            }),
                            "\xa0 \xa0",
                            values.slug && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_SlugLink__WEBPACK_IMPORTED_MODULE_5__/* .SlugLink */ .$, {
                                href: extendRoute(constants_routes__WEBPACK_IMPORTED_MODULE_7__/* .ROUTES.AUTH_FORGOT_PASSWORD */ .Z.AUTH_FORGOT_PASSWORD, values.slug, isGeneral),
                                passHref: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                    color: "textSecondary",
                                    variant: "body2",
                                    children: t("login.forgot_password")
                                })
                            })
                        ]
                    })
                ]
            }));
        }
    }));
};


/***/ }),

/***/ 9952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ FormikTextField; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22715);
/* harmony import */ var _mui_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66684);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82580);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var useStyles = (0,_mui_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    rounded: {
        borderRadius: "16px"
    }
});
var FormikTextField = function(props) {
    var classes = useStyles();
    var rounded = props.rounded, allProps = _objectWithoutProperties(props, [
        "rounded"
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(formik__WEBPACK_IMPORTED_MODULE_1__/* .FastField */ .Rt, {
        name: allProps.name,
        children: function(param) {
            var field = param.field, meta = param.meta;
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _objectSpread({
                "data-testid": allProps.name,
                error: Boolean(meta.touched && meta.error),
                helperText: meta.touched && meta.error,
                variant: "outlined",
                fullWidth: true
            }, field, allProps, {
                InputProps: {
                    classes: {
                        root: rounded ? classes.rounded : ""
                    }
                }
            }));
        }
    }));
};



/***/ }),

/***/ 46648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ROUTES; }
/* harmony export */ });
/**
 * Global routes table
 */ var ROUTES = {
    // Dashboard
    DASHBOARD_ROOT: "/dashboard",
    DASHBOARD_ADMIN: "/dashboard",
    DASHBOARD_USER: "/dashboard/user",
    TEST: "/dashboard/test",
    FLOURISHING_PROFILE: "/dashboard/flourishing-profile",
    // Auth
    AUTH_LOGIN: "/authentication/login",
    AUTH_FORGOT_PASSWORD: "/authentication/forgot-password",
    AUTH_CHANGE_PASSWORD: "/authentication/change-password",
    AUTH_RESET_PASSWORD: "/authentication/forgot-password-reset",
    AUTH_VERIFY_MFA: "/authentication/verify-mfa",
    AUTH_REGISTER: "/join-code/register",
    AUTH_JOIN_CODE: "/join-code",
    AUTH_UNIQUE_ID: "/join-code/unique-id",
    // Test management
    TESTS_ASSIGN: "/tests/assign",
    TESTS_EDIT: "/tests/edit",
    TESTS_LIST: "/tests",
    TESTS_CREATE: "/tests/create",
    TESTS_STATUS: "/tests/status",
    TESTS_NO_TEST: "/tests/no-test",
    TESTS_COMPLETED_TEST: "/tests/completed-test",
    CUSTOM_REPORTS: "/tests/custom-reports",
    CUSTOM_REPORTS_VIEW_SINGLE: "/tests/custom-reports/view",
    CUSTOM_REPORTS_CREATE: "/tests/custom-reports/create",
    // Client management
    CLIENT_ROOT: "/clients",
    CLIENT_JOIN_CODE: "/clients/join-code",
    CLIENT_MANAGER: "/clients",
    CLIENT_CREATE: "/clients/create",
    CLIENT_VIEW_SINGLE: "/clients/view",
    // Reports
    REPORTS_ROOT: "/reports",
    REPORTS_CORE_COMPETENCY: "/reports/core-competency",
    REPORTS_NINE_HABITS: "/reports/nine-habits",
    REPORTS_CUSTOM_QUESTIONS: "/reports/custom-questions-report",
    REPORTS_FLOURISHING_MINDSETS: "/reports/flourishing-mindsets",
    REPORTS_PERFORMANCE_CAPACITY: "/reports/performance-capacity",
    REPORTS_RESILIENCE_CAPACITY: "/reports/resiliency-capacity",
    REPORTS_SEVEN_WELL_BEING_FACTORS: "/reports/seven-well-being-factors",
    REPORTS_FLOURISHING_SUMMARY: "/reports/flourishing-summary",
    REPORTS_CLIENT_LIST: "/reports/client-list",
    REPORTS_CUSTOM_BASE: "/reports/custom-report-base",
    // Trend views
    TRENDS_RESILIENCE_CAPACITY: "/trends/resiliency-capacity",
    TRENDS_PERFORMANCE_CAPACITY: "/trends/performance-capacity",
    TRENDS_SEVEN_WELL_BEING_FACTORS: "/trends/seven-well-being-factors",
    TRENDS_CORE_COMPETENCY: "/trends/core-competency",
    TRENDS_FLOURISHING_MINDSET: "/trends/flourishing-mindset",
    TRENDS_NINE_HABITS: "/trends/nine-habits",
    TRENDS_FLOURISHING_SUMMARY: "/trends/flourishing-summary",
    TRENDS_CUSTOM_BASE: "/trends/custom-trend-base",
    // FL Admin
    LICENSE_MANAGER: "/fl-admin/license-manager",
    INSTANCE_EDIT: "/fl-admin/organization-manager/edit",
    INSTANCE_CREATE: "/fl-admin/organization-manager/create",
    INSTANCE_LIST: "/fl-admin/organization-manager",
    // Misc
    UNAUTHORIZED: "/unauthorized",
    PROFILE: "/profile"
};


/***/ })

}]);